import { render, staticRenderFns } from "./HorseListe.vue?vue&type=template&id=4a16c07d&"
import script from "./HorseListe.vue?vue&type=script&lang=js&"
export * from "./HorseListe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports